import { InputLocalStorage } from "utils/InputLocalStorage";
const contactFormInputNamesLS = new InputLocalStorage({
  name: "eventName",
  email: "clientEmail",
  date: "eventDate",
  location: "eventLocation",
  budget: "EventBudget",
  message: "clientMessage",
  services: "otherServices",
});
export { contactFormInputNamesLS };
